import agentsBR from './agents.br';
import agentsCL from './agents.cl';
import agentsCO from './agents.co';
import agentsES from './agents.es';
import agentsMX from './agents.mx';

const agents = {
  BR: agentsBR,
  CL: agentsCL,
  CO: agentsCO,
  ES: agentsES,
  MX: agentsMX,
};

export default agents;
